import { Typography, Stack, Box, IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useAppStore } from '../../../store/appStore';


export default function ApprovalHierarchyHeader({ headerName = 'Pass Header From Prop', buttons = [], requiredFilterData }) {
    const [requiredData, setRequiredData] = useState(requiredFilterData); // NOSONAR
     

    const {
     hoverFilterValues
    } = useAppStore();

    useEffect(() => {
        setRequiredData(requiredFilterData);
    }, [requiredFilterData]);

    const formatValue = (value) => {
        if (Array.isArray(value)) {
            return value.map(formatValue);
        }
        if (typeof value === 'object' && value !== null) {
            return Object.entries(value).map(([key, val]) => `${key}: ${formatValue(val)}`);
        }
        
        return value !== null && value !== undefined ? value.toString() : '';
    };
    
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            p={2}
            sx={{ padding: "0px 16px 10px 0px" }}
        >       
            <Typography variant="h6">{headerName}</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {buttons.map(({ title, icon, onClick, sx }, index) => {
                    let tooltipTitle;

                    if (title === 'Filter') {
                        tooltipTitle = hoverFilterValues && Object.keys(hoverFilterValues).length !== 0 ? (
                            <Box sx={{ bgcolor: 'white', color: '#000', p: 1, borderRadius: 1, maxWidth: 200 }}>

                                <Stack direction="column" alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                                    {hoverFilterValues.map((data, index1) => (
                                        <div key={index1}> { /* NOSONAR */ }
                                            {Object.entries(data).map(([key, value]) => (
                                                <Typography variant='body2' key={key}>
                                                    <span style={{ fontWeight: 'bold' }}>{key}:</span> {formatValue(value)}
                                                </Typography>
                                            ))}
                                        </div>
                                    ))}
                                </Stack>
                            </Box>
                        ) : 'Filter';
                    } else {
                        tooltipTitle = title;
                    }

                    return (
                        <Tooltip
                            key={index} // NOSONAR
                            title={tooltipTitle}
                            sx={{
                                "& .MuiTooltip-tooltip": {

                                    bgcolor: 'transparent', // Make tooltip background transparent
                                    border: 'none', // Remove any border
                                    boxShadow: 'none' // Remove shadow
                                }
                            }}
                        >
                            <IconButton onClick={onClick} sx={{ marginLeft: 2, borderRadius: '8px', ...sx }}>
                                <Iconify icon={icon} sx={{ transform: 'scale(3)' }} />
                            </IconButton>
                        </Tooltip>
                    );
                })}
            </Box>
        </Stack>
    );
}

ApprovalHierarchyHeader.propTypes = {
    headerName: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            sx: PropTypes.object,
        })
    ).isRequired,
    requiredFilterData: PropTypes.any.isRequired
};
